export default function Messages({ children }) {
    return (
      <div
        className="relative w-full h-[calc(100vh_-_197px)] p-6 overflow-y-auto flex flex-col-reverse"
        id="scrollableDiv"
      >
        <ul className="space-y-6">{children}</ul>
      </div>
    );
  }
  